import { apiRequest } from './client';
import type { ActivityLogItem, PaginatedResponse } from '../types/admin';

export type ListActivityParams = {
  readonly page?: number;
  readonly page_size?: number;
  readonly admin_id?: string;
  readonly action?: string;
  readonly entity_type?: string;
  readonly date_from?: string;
  readonly date_to?: string;
  readonly search?: string;
};

export async function getActivityLogs(
  params: ListActivityParams = {},
  accessToken: string,
): Promise<PaginatedResponse<ActivityLogItem>> {
  const { page = 1, page_size = 10, ...filters } = params;
  const query = new URLSearchParams({
    page: String(page),
    page_size: String(page_size),
  });

  for (const [key, value] of Object.entries(filters)) {
    if (value) {
      query.set(key, value);
    }
  }

  return apiRequest<PaginatedResponse<ActivityLogItem>>(`/admin/activity?${query.toString()}`, {
    token: accessToken,
  });
}

export async function getRecentActivityLogs(
  accessToken: string,
  limit: number = 5,
): Promise<readonly ActivityLogItem[]> {
  return apiRequest<readonly ActivityLogItem[]>(`/admin/activity/recent?limit=${limit}`, {
    token: accessToken,
  });
}
